
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useContext, useEffect, useRef, useState } from "react";
import { AiOutlineClear } from 'react-icons/ai';
import { FaRegCopy } from 'react-icons/fa';
import { FiLayers } from 'react-icons/fi';

import { MenuContext } from "../../../../context/MenuContext";
import { Category } from "../../../../components/Category";
import { Toast } from "../../../../utils/Toast";
import { api } from "../../../../api/api";
import _ from "lodash";

export default function Cardapio({ isLocal = false }) {
  const { data, setData, isDragging, copyAndPaste, setCopyAndPaste, load } = useContext(MenuContext)
  const [timer, setTimer] = useState(null)
  const dragItem = useRef();
  const dragOverItem = useRef();

  async function updated(items) {
    const calculate = items.map((e, index) => {
      return {
        id: e.id,
        name: e.name,
        [isLocal ? 'assortment_local' : 'assortment']: index + 1
      }
    })

    clearTimeout(timer)

    const newTimer = setTimeout(async () => {
      await api.put('/category/categories/assortment', calculate)
        .then(async () => {
          Toast.success("Informação atualizada.")
          await load()
        })
    }, 1000)

    setTimer(newTimer)
  }

  const dragStart = (e, position) => {
    dragItem.current = position;
  };

  const dragEnter = (e, position) => {
    dragOverItem.current = position;
  };

  const drop = (e) => {
    const copyListItems = _.orderBy([...data], (isLocal ? 'assortment_local' : 'assortment'), 'asc');
    const dragItemContent = copyListItems[dragItem.current];
    copyListItems.splice(dragItem.current, 1);
    copyListItems.splice(dragOverItem.current, 0, dragItemContent);
    dragItem.current = null;
    dragOverItem.current = null;
    setData(copyListItems);
    updated(copyListItems)
  };

  useEffect(() => {
    load(isLocal)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <div className="menu-catalog">
          {copyAndPaste &&
            <div className="menu-copy-alert" role="alert">
              <strong> <FaRegCopy />  Selecione para qual produto deseja copiar as informações</strong>
              <button onClick={() => setCopyAndPaste('')}>
                <AiOutlineClear size={18} /> Cancelar cópia
              </button>
            </div>
          }

          <div className="menu-catalog-heading"><div><span><FiLayers /></span><div><h2>Categorias</h2><p>{data?.length || 0} categorias neste cardápio</p></div></div></div>
          <div className="accordion menu-categories" id="categories">
            {_.orderBy(data, (isLocal ? 'assortment_local' : 'assortment'), 'asc')?.map((item, index) => {
              return (
                <div
                  onDragStart={(e) => (isDragging.name === 'category') ? dragStart(e, index) : null}
                  onDragEnter={(e) => (isDragging.name === 'category') ? dragEnter(e, index) : null}
                  onDragEnd={() => (isDragging.name === 'category') ? drop() : null}
                  draggable={(isDragging.name === 'category') ? true : false}
                  key={item.id}
                >
                  <Category key={item.id} item={item} />
                </div>
              )
            })}
          </div>
      </div>
    </>
  )
}
